import NimasaAgentMain from "../modules/nimasaAgentModule/views/Main.vue";
import Dashboard from "../modules/nimasaAgentModule/views/Dashboard.vue";
import AgentGuide from "../modules/nimasaAgentModule/views/Guide";
import AgentAcceptedApplications from "../modules/nimasaAgentModule/views/AcceptedApplications";
import AgentRejectedApplications from "../modules/nimasaAgentModule/views/RejectedApplications";
import PendingReview from "../modules/nimasaAgentModule/views/ShippingRequests.vue";
import ActivePortsReport from "../modules/nimasaAgentModule/views/reports/ActivePortsReport";
import AgentShippingApplicationsReport from "../modules/nimasaAgentModule/views/reports/DangerousGoodsReport";
import ShippersReport from "../modules/nimasaAgentModule/views/reports/ShippersReport";
import Profile from "../modules/nimasaAgentModule/views/Profile.vue";
import ManagerDashboard from "../modules/nimasaAgentModule/views/NimasaManager/Dashboard.vue";
import ManagerAwaitingApproval from "../modules/nimasaAgentModule/views/NimasaManager/AwaitingApproval.vue";
import ManagerApprovedApplications from "../modules/nimasaAgentModule/views/NimasaManager/ApprovedApplications.vue";
import ManagerAllApplications from "../modules/nimasaAgentModule/views/NimasaManager/AllApplications.vue";
import ManagerDisapprovedApplications from "../modules/nimasaAgentModule/views/NimasaManager/DisapprovedApplications.vue";
import ManagerActivePortsReport from "../modules/nimasaAgentModule/views/NimasaManager/reports/ActivePortsReport";
import ManagerShippingApplicationsReport from "../modules/nimasaAgentModule/views/NimasaManager/reports/DangerousGoodsReport";
import ManagerShippersReport from "../modules/nimasaAgentModule/views/NimasaManager/reports/ShippersReport";
import ManagerGuide from "../modules/nimasaAgentModule/views/NimasaManager/Guide";
import ManagerProfile from "../modules/nimasaAgentModule/views/NimasaManager/Profile.vue";
import PortReportDetails from "../modules/nimasaAgentModule/views/NimasaManager/reports/PortReportDetails"

export default [
  {
    path: "/nimasa",
    name: "nimasa-main-view",
    component: NimasaAgentMain,
    children: [
      {
        path: "/nimasa-agent/dashboard",
        name: "nimasa-agent-dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/review-applications",
        name: "review-applications",
        component: PendingReview,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/accepted-applications",
        name: "accepted-applications",
        component: AgentAcceptedApplications,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/rejected-applications",
        name: "rejected-applications",
        component: AgentRejectedApplications,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/reports/shipping-applications",
        name: "nimasa-shipping-applications-report",
        component: AgentShippingApplicationsReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/reports/active-ports",
        name: "nimasa-active-ports-report",
        component: ActivePortsReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/reports/shippers",
        name: "nimasa-shippers-report",
        component: ShippersReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/guide",
        name: "nimasa-agent-guide",
        component: AgentGuide,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-agent/profile-settings",
        name: "nimasa-agent-profile-settings",
        component: Profile,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/dashboard",
        name: "nimasa-manager-dashboard",
        component: ManagerDashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/approve-applications",
        name: "approve-applications",
        component: ManagerAwaitingApproval,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/approved-applications",
        name: "approved-applications",
        component: ManagerApprovedApplications,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/disapproved-applications",
        name: "disapproved-applications",
        component: ManagerDisapprovedApplications,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/all-applications",
        name: "all-applications",
        component: ManagerAllApplications,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/reports/shipping-applications",
        name: "nimasa-manager-shipping-applications-report",
        component: ManagerShippingApplicationsReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/reports/active-ports",
        name: "nimasa-manager-active-ports-report",
        component: ManagerActivePortsReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/reports/active-ports/:id",
        name: "port-report-details",
        component: PortReportDetails,
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/reports/shippers",
        name: "nimasa-manager-shippers-report",
        component: ManagerShippersReport,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/manager-guide",
        name: "nimasa-manager-guide",
        component: ManagerGuide,
        meta: { requiresAuth: true }
      },
      {
        path: "/nimasa-manager/profile-settings",
        name: "nimasa-manager-profile-settings",
        component: ManagerProfile,
        meta: { requiresAuth: true }
      },
    ]
  }
];
